import { useMemo } from "react";
import { useDispatchColors } from "@/hooks";

export const useDispatchSchedulerTheme = () => {
  const { getEventColor, getGridCellColor, workHours } = useDispatchColors();

  return useMemo(
    () => ({
      eventTextColor: "#ffffff",
      eventDropTargetColor: "#dbeafe",
      getEventColor,
      getEventHoverColor: (_event, baseColor) => baseColor,
      getGridCellColor,
      getWorkHours: () => workHours,
    }),
    [getEventColor, getGridCellColor, workHours]
  );
};
